<script lang="ts">
  import {
    isLoading,
    isFirefox,
    showController,
    showGuides,
    showSample,
    showLS,
    showRS,
    showLT,
    showRT,
    showLB,
    showRB,
    sampleContent,
    displayMode,
    buttonStyle,
    buttonSwap,
    controllerConnected,
  } from './stores'; /* Load Global Data */

  import { fade, fly } from 'svelte/transition';
  export let show = false;

  function toggleSplash() {
    $isLoading = !$isLoading;
  } /* Toggle Splash Screen On / Off */
  function toggleFirefox() {
    $isFirefox = !$isFirefox;
  } /* Toggle between Firefox / Default styles */

  function toggleGuides() {
    $showGuides = !$showGuides;
  } /* Toggle between Guides On / Off */
  function toggleSample() {
    $showSample = !$showSample;
  } /* Toggle between Sample On / Off */
  function toggleController() {
    $showController = !$showController;
  } /* Toggle between Controller On / Off */

  /* Layout Components */
  function toggleLeftStick() {
    $showLS = !$showLS;
  } /* Toggle Left Stick */
  function toggleRightStick() {
    $showRS = !$showRS;
  } /* Toggle Right Stick */
  function toggleLeftTrigger() {
    $showLT = !$showLT;
  } /* Toggle Left Trigger */
  function toggleRightTrigger() {
    $showRT = !$showRT;
  } /* Toggle Right Trigger */

  /* Increment Button Counts */
  function toggleLeftButtons() {
    $showLB < 1 ? $showLB++ : ($showLB = 0);
  }
  function toggleRightButtons() {
    $showRB < 4 ? $showRB++ : ($showRB = 0);
  }

  /* Toggle between Bright / Dark gameplay content */
  function toggleContent() {
    $sampleContent == 'flying'
      ? sampleContent.set('racing')
      : sampleContent.set('flying');
  }
  /* Toggle between Cover / Contain Gameplay */
  function toggledisplayMode() {
    $displayMode == 'contain'
      ? displayMode.set('cover')
      : displayMode.set('contain');
  }
  /* Toggle between Button Colour Styles */
  function toggleButtonStyle() {
    $buttonStyle == 'default'
      ? buttonStyle.set('mtn')
      : $buttonStyle == 'mtn'
      ? buttonStyle.set('colour')
      : buttonStyle.set('default');
  }
  /* Toggle Left/Right mode */
  function toggleSwap() {
    $buttonSwap = !$buttonSwap;
  }
  /* Toggle Bluetooth mode */
  function toggleBluetooth() {
    $controllerConnected = !$controllerConnected;
  }
</script>

{#if show}
  <nav in:fade out:fade>
    <!-- <button on:click|preventDefault={() => {modal_show = true; show = false;}}>About</button> -->

    <div class="container">
      <div class="col">
        <div class="row">
          <button on:click|preventDefault={toggleFirefox}
            >Firefox: {$isFirefox}</button
          >
          <button on:click|preventDefault={toggleGuides}
            >Guides: {$showGuides}</button
          >
        </div>
        <div class="row">
          <button on:click|preventDefault={toggleSample}
            >Sample: {$showSample}</button
          >
          <button on:click|preventDefault={toggledisplayMode}
            >Display: {$displayMode}</button
          >
        </div>
        <div class="row">
          <button on:click|preventDefault={toggleController}
            >Controller: {$showController}</button
          >
          <button on:click|preventDefault={toggleButtonStyle}
            >Theme: {$buttonStyle}</button
          >
        </div>

        <div class="row">
          <div class="col red">
            <button on:click|preventDefault={toggleLeftStick}
              >Stick: {$showLS}</button
            >
            <button on:click|preventDefault={toggleLeftButtons}
              >Buttons: {$showLB}</button
            >
            <button on:click|preventDefault={toggleLeftTrigger}
              >Triggers: {$showLT}</button
            >
          </div>
          <div class="col blue">
            <button on:click|preventDefault={toggleRightStick}
              >Stick: {$showRS}</button
            >
            <button on:click|preventDefault={toggleRightButtons}
              >Buttons: {$showRB}</button
            >
            <button on:click|preventDefault={toggleRightTrigger}
              >Triggers: {$showRT}</button
            >
          </div>
        </div>

        <div class="row">
          <button on:click|preventDefault={toggleSwap}
            >Swap Buttons: {$buttonSwap}</button
          >
        </div>

        <div class="row">
          <button on:click|preventDefault={toggleBluetooth}
            >Bluetooth Controller: {$controllerConnected}</button
          >
        </div>

      </div>
    </div>
  </nav>
{/if}

<!-- <Modal bind:show={modal_show} /> -->
<style>
  nav {
    position: fixed;
    top: 0;
    left: 35vw;
    width: 25vw;
    height: 100vh;
    padding: 2rem 1rem 0.6rem;
    border-left: 1px solid #aaa;
    background: #fff;
    overflow-y: auto;
    z-index: 5000;
  }
  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
    z-index: 1002;
  }
  .red button {
    background-color: red;
    color: white;
  }
  .blue button {
    background-color: blue;
    color: white;
  }
  .col {
    /* border: 1px solid blue; */
    /* width: 100px; */
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .row {
    /* border: 1px solid green; */
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  button {
    /* border: 1px solid red; */
    margin-bottom: 5px;
    margin-top: 0;
    font-size: 10px;
    min-width: 48%;
  }
</style>
